document.addEventListener("DOMContentLoaded", () => {
    /**
     * Selects a random subset of items from an array using the Fisher-Yates shuffle.
     * @param {Array} arr - The array to select from.
     * @param {number} count - Number of items to select.
     * @returns {Array} A new array containing 'count' randomly selected items.
     */
    const getRandomSubset = (arr, count) => {
      const shuffled = [...arr];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled.slice(0, count);
    };

    /**
     * Updates the alt attribute for images that don't already have alt text.
     *
     * @param {string[]} keywords - An array of high-ranking keywords.
     * @param {string} [selector='img'] - CSS selector to target specific images.
     * @param {number} [subsetSize=5] - Number of keywords to use per image.
     */
    const updateImageAlts = (keywords, selector = "img", subsetSize = 4) => {
      if (!Array.isArray(keywords) || keywords.length === 0) return;

      const images = document.querySelectorAll(selector);
      images.forEach((img) => {
        // Only update images that lack a meaningful alt attribute.
        if (!img.hasAttribute("alt") || img.alt.trim() === "") {
          const selectedKeywords = getRandomSubset(keywords, subsetSize);
          img.alt = selectedKeywords.join(", ");
        }
      });
    };

    // Define your high-ranking keywords (extend this array as needed).
    const highRankingKeywords = [
      "toys from toys",
      "toys to toys",
      "toys & toys",
      "wooden toys",
      "play toys",
      "toys for bath",
      "woodcraft toys",
      "uae toys",
      "childs wooden kitchen set",
      "play play toy",
      "kitchen sets toys",
      "toy kitchen toy",
      "wooden childs toys",
      "toys education",
      "toys in education",
      "hape toys",
      "wooden walker",
      "hape wooden toys",
      "hape walker",
      "walker toys",
      "hape puzzles",
      "set toys",
      "sustainable toys",
      "hape doll house",
      "hape kitchen",
      "mumzworld toys",
      "toys puzzles",
      "wooden kitchen toys",
      "pull along toys",
      "wooden toy garage",
      "rainbow toys",
      "puzzles hape",
      "hape crane",
      "hape garage",
      "kitchen playsets",
      "park toys",
      "toys and puzzles",
      "toys online shopping",
      "magnetic alphabet",
      "play kitchen toys",
      "house toys",
      "educational wooden toys",
      "toys delivery",
      "wooden shop toy",
      "toys for 2 years",
      "puzzles and toys",
      "hape toy kitchen",
      "hape wooden kitchen",
      "kitchen accessories toys",
      "woodshop toys",
      "toys for 4 years",
      "fast delivery toys",
      "parking garage toys",
      "wooden toys dubai",
      "a toy set",
      "dolls for the bath",
      "hape doctor set",
      "wooden toys for kitchen",
      "shipping toys",
      "shop wooden toys",
      "toys online toys",
      "wooden toys uae",
      "garage wooden toy",
      "kitchen hape",
      "sort toys",
      "toy kitchen hape",
      "toys ae",
      "toys construction set",
      "toys creative",
      "toys for delivery",
      "wooden toys for childrens kitchen",
      "wooden toys house",
      "hape tablet",
      "hape store",
      "hape toys",
      "hape train set",
      "train set hape",
      "hape marble run",
      "hape easel",
      "hape train",
      "hape kitchen set",
      "hape puzzle",
      "hape walker",
      "hape wooden dollhouse",
      "marble run hape",
      "hape wonder walker",
      "hape drum set",
      "hape marble",
      "puzzle hape",
      "hape my first musical walker",
      "hape wooden walker",
      "hape paper roll",
      "hape drum kit",
      "hape passenger train set",
      "hape toys marble run",
      "wooden hape dollhouse"
    ];

    updateImageAlts(highRankingKeywords);
  });
